export default __webpack_public_path__ + "static/media/arrow-right-positive.752aeba3.svg";